import Page, {BillingChangeSubscriptionProps as PageProps} from './index';

const WithState = (props: PageProps) => <Page {...props} />;

export default WithState;
